import { render, staticRenderFns } from "./SortAscendingIcon.vue?vue&type=template&id=2329b41f&"
import script from "./SortAscendingIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SortAscendingIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports